import { ListItem, ListItemButton, Stack, Typography, useTheme } from '@mui/material'

export interface TemplateRowProps {
  templateName: string
  templateExternalName: string
  customerCount: number
  onClick: () => void
}

export const TemplateRow = ({ templateName, templateExternalName, customerCount, onClick }: TemplateRowProps) => {
  const { palette } = useTheme()

  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemButton onClick={onClick}>
        <Stack
          direction="row"
          sx={{
            padding: 2,
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Typography data-testid="template-external-name" variant="p1Medium">
              {templateExternalName}
            </Typography>
            <Typography data-testid="template-name" variant="subtitle1" sx={{ color: palette.text.secondary }}>
              {templateName}
            </Typography>
          </Stack>
          <Stack
            sx={{
              justifySelf: 'flex-end',
            }}
          >
            <Typography variant="p3Medium">{customerCount} Customers</Typography>
          </Stack>
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
